import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

// Masked headline wrapper — static & always visible (reliable across environments)
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block ${className}`}>{children}</span>
);

export const Overline = ({ children, className = "" }) => (
  <span className={`text-xs md:text-sm font-medium tracking-[0.22em] uppercase text-foreground/65 font-sans ${className}`}>
    {children}
  </span>
);
